module.exports = __webpack_public_path__ + "static/media/simplify.fe8c0359.jpg";